import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BasicFilters } from '../model/filters/basic-filters';
import { Observable } from 'rxjs';
import { MeasurementTypesResponse } from '../model/responses/measurement-types-response';
import { HttpUtils } from '../shared/http.utils';
import { MeasurementTypePersistRequest } from '../model/requests/measurement-type-persist-request';
import { MeasurementTypeFilters } from "../model/filters/measurement-type-filters";

@Injectable({
  providedIn: 'root'
})
export class MeasurementTypesService {

  private readonly measurementTypesURL: string;

  constructor(private http: HttpClient) {
    this.measurementTypesURL = '/catalog/measurement_types';
  }

  public getMeasurementTypes(offset?: number, limit?: number, filters?: MeasurementTypeFilters): Observable<MeasurementTypesResponse>{
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new BasicFilters();
    return this.http.post<MeasurementTypesResponse>(this.measurementTypesURL, body, options);
  }

  public createMeasurementType(measurementTypePersistRequest: MeasurementTypePersistRequest): Observable<void> {
    const url = `${this.measurementTypesURL}/create`;
    return this.http.post<void>(url, measurementTypePersistRequest);
  }

  public editMeasurementType(measurementTypePersistRequest: MeasurementTypePersistRequest): Observable<void> {
    const url = `${this.measurementTypesURL}/edit`;
    return this.http.post<void>(url, measurementTypePersistRequest);
  }

  public deleteMeasurementTypes(identifiers: {tenantUuid: string, sensor: string}[]): Observable<void> {
    const url = `${this.measurementTypesURL}/delete`;
    return this.http.post<void>(url, identifiers);
  }

}
